<template>
  <v-row id="termLifeCardHeader" class="mt-0">
    <v-col
      cols="12"
      md="4"
      :class="$vuetify.display.smAndUp ? 'pt-4' : 'pt-2'"
      class="pl-6 border_bottom_line"
    >
      <v-icon color="#063562" :icon="mdiFileDocument" />
      <span v-if="isPendingPolicy"> {{ $t('L_policy_number_application') }}: </span>
      <span v-else> {{ $t('L_policy_number') }}: </span>
      <span class="font-weight-bold">
        {{ policyList[indexPolicy]?.contractId }}
      </span>
    </v-col>
    <v-col
      cols="6"
      md="3"
      class="text-left pr-4 pb-2 border_bottom_line"
      :class="$vuetify.display.smAndUp ? 'pt-4' : 'pt-1 pb-2'"
    >
      <span
        @click="setPolicyRtPolicyDetails"
        class="view_details_class"
        v-if="showPolicyDetailsLink"
      >
        {{ $t('L_policy_details') }}
      </span>
    </v-col>
    <v-col
      cols="6"
      md="5"
      :class="$vuetify.display.smAndUp ? 'pt-4' : 'pt-1 pb-2'"
      class="border_bottom_line text-right pb-2 pr-6"
    >
      <span class="text-right">
        <span>{{ $t('L_status') }}</span>
        <span class="ml-3">
          <v-icon
            class="policy-status-icon"
            :color="policyStatusIconColor"
            :icon="policyStatusIcon"
          />
          <span class="font-size--14">
            {{ policyStatusDescription }}
          </span>
        </span>
      </span>
    </v-col>
  </v-row>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import type { IPolicyStorePolicy } from '@/modules/policy/store/policyStore.model';
import { mdiAlertCircle, mdiCheckCircle, mdiClockTimeFour, mdiFileDocument } from '@mdi/js';
import { mapStores } from 'pinia';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'TermLifeCardHeader',
  data() {
    return { mdiAlertCircle, mdiCheckCircle, mdiClockTimeFour, mdiFileDocument };
  },
  props: {
    indexPolicy: {
      type: Number,
      required: true,
      default: 0,
    },
  },
  computed: {
    ...mapStores(usePolicyStore),
    selectedPolicy(): IPolicyStorePolicy {
      return this.policyStore.policies[this.indexPolicy];
    },
    isPendingPolicy() {
      return this.selectedPolicy?.pending === true;
    },
    isAccessNone() {
      return this.selectedPolicy?.data?.access === 'NONE';
    },
    isEligibleForReinstatement() {
      return (
        this.selectedPolicy?.reinstatement && this.selectedPolicy?.reinstatement?.eligible === true
      );
    },
    isTerminated() {
      return (
        this.selectedPolicy?.terminated || this.selectedPolicy?.policyStatusDesc === 'Terminated'
      );
    },
    policyList() {
      return this.policyStore.policies.map((p: IPolicyStorePolicy) => ({
        contractId: p.contractId,
      }));
    },
    showPolicyDetailsLink() {
      return !this.isAccessNone && !this.isEligibleForReinstatement;
    },
    policyStatusIcon() {
      let icon;
      if (this.isTerminated) {
        icon = mdiAlertCircle;
      } else if (this.selectedPolicy?.pending) {
        icon = mdiClockTimeFour;
      } else {
        icon = mdiCheckCircle;
      }
      return icon;
    },
    policyStatusIconColor() {
      // return 'error';
      let color;
      if (this.isTerminated) {
        color = 'error';
      } else if (this.selectedPolicy?.pending) {
        color = '#ee7026';
      } else {
        color = '#0b8d1f';
      }
      return color;
    },
    policyStatusDescription() {
      let description;
      if (this.isTerminated) {
        description = this.$t('L_terminated_application');
      } else if (this.selectedPolicy?.pending) {
        description = this.$t('L_active_application');
      } else {
        description = this.$t('L_active');
      }
      return description;
    },
  },
  methods: {
    async setPolicyIndex() {
      await this.policyStore.changePolicy({ selectedIndex: this.indexPolicy });
      await this.policyStore.getPaymentInfo(
        this.policyStore.policies[this.indexPolicy]?.contractId
      );
    },
    async setPolicyRtPolicyDetails() {
      this.setPolicyIndex();
      await this.$router.push({
        name: RouteNames.POLICY_DETAILS,
        params: { contractId: this.indexPolicy },
      });
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.border_bottom_line {
  border-bottom: 1px solid black;
  padding-bottom: 10px;
}

.view_details_class {
  font-size: 16px;
  color: #0c6dca;
  padding-left: 27px;
  font-weight: bold;
  cursor: pointer;
  float: left;
}
</style>
